module.exports = __webpack_public_path__ + "media/src/website/images/locations/fridolfing/profile-f47a65c6af30f5a6322698235d2abd20.jpg";